export default {
    slug: 'sso',
    settingsRoutes: [
        {
            path: 'sso',
            name: 'settings-sso',
            component: () => import('@modules/Sso/Resources/js/pages/settings/SsoSettings.vue'),
            props: true
        }
    ],
    settings: () => [
        {
            title: i18n.t('Administration'),
            order: 30,
            items: [{ title: i18n.t('Single Sign-On'), icon: 'shield-lock', route: 'settings-sso', admin: true }]
        }
    ]
};
